import React from "react";
import "./TextBox.scss";

const TextArea = ({
  name = "", // name to textarea
  children, // value of text area
  size = "md", // text area size
  widthSize, // text are width
  disabled = false, // is disabled
  className = "",
  placeholder = "",
  ...props
}) => {
  const prenetClasses = `borderWrapper ${className} ${
    disabled ? "disabled" : ""
  }`; // text are parent classes
  const classes = `input textArea borderInner ${size} ${
    widthSize ? "Width-" + widthSize : ""
  } ${disabled ? "disabled" : ""}`; // text area classes

  return (
    <div className={prenetClasses}>
      <textarea
        className={classes}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      >
        {children}
      </textarea>
    </div>
  );
};

export default TextArea;
